module.exports = __webpack_public_path__ + "static/mapa-99f3dc2482798ab266dc35d03f8fd35e.jpg";